import { render, staticRenderFns } from "./SevDeskProfitLoss.vue?vue&type=template&id=6b35a0d2&"
import script from "./SevDeskProfitLoss.vue?vue&type=script&lang=js&"
export * from "./SevDeskProfitLoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports